export const prepareModules = function (modules = []) {
    let modules_count = 0
    let _modules = structuredClone(modules)
    _modules.forEach((module, m_id)=>{
        modules_count++
        module["correct_answer_score"] = parseFloat(module["correct_answer_score"]) || 0;
        module["wrong_answer_score"] = parseFloat(module["wrong_answer_score"]) || 0;
        module["omitted_answer_score"] = parseFloat(module["omitted_answer_score"]) || 0
        if(module['time'])
            module['time']= parseInt(module['time'])
        if(module['num_questions_per_module'])
            module['num_questions_per_module']= parseInt(module['num_questions_per_module'])
        if(module['thresholds']?.length > 0){
            module['thresholds'] = module['thresholds'].map((t)=>{
                if(t.threshold_name){
                    const base = {
                        threshold_name: t.threshold_name,
                        is_showable: !!t.is_showable,
                        score: parseFloat(t.score),
                        threshold_type: t.threshold_type
                    }
                    switch(t.threshold_type){
                        case 'certificate_generation':
                            return {
                                ...base,
                                ...(t.pdf_certificate_template_url && { pdf_certificate_template_url: t.pdf_certificate_template_url }),
                                show_scores: t.show_scores !== false,
                                show_title: t.show_title !== false
                            }
                        case 'esse3_passing_score_threshold':
                            return {
                                ...base,
                                ad_cod: t.ad_cod || ''
                            }
                        case 'esse3_add_to_libretto_threshold':
                            return {
                                ...base,
                                ad_cod: t.ad_cod || '',
                                ad_des: t.ad_des || '',
                                cds_id: t.cds_id !== undefined && t.cds_id !== '' ? parseInt(t.cds_id) : undefined,
                                cds_cod: t.cds_cod || '',
                                pds_id: t.pds_id !== undefined && t.pds_id !== '' ? parseInt(t.pds_id) : undefined,
                                pds_cod: t.pds_cod || '',
                                add_when_passed: !!t.add_when_passed
                            }
                        case 'subject_passing_score_threshold':
                            return {
                                ...base,
                                subject_id: t.subject_id || ''
                            }
                        case 'add_to_group_threshold':
                            return {
                                ...base,
                                group_id: t.group_id || ''
                            }
                        default:
                            return base
                    }
                }
            })
        }
    })
    if(modules_count > 0){
        return {
            modules: _modules
        }
    } else {
       return false
    }
    
}

export const prepareQuestions = function (modules = []) {
    let modules_count = 0
    let _modules = structuredClone(modules)
    _modules.forEach((module, m_id)=>{
        modules_count++
        module["correct_answer_score"] = parseFloat(module["correct_answer_score"]) || 0;
        module["wrong_answer_score"] = parseFloat(module["wrong_answer_score"]) || 0;
        module["omitted_answer_score"] = parseFloat(module["omitted_answer_score"]) || 0
        if(module['time'])
            module['time']= parseInt(module['time'])
        if(module['num_questions_per_module'])
            module['num_questions_per_module']= parseInt(module['num_questions_per_module'])
    })
    if(modules_count > 0){
        return {
            modules: _modules
        }
    } else {
       return false
    }
    
}